<template>
  <patientComponent :hireState="1"></patientComponent>
</template>
<script>

import patientComponent from '@/components/fetalMonitor/patient.vue'
export default {
  name: `fetalMonitorallUser`,
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
  },
  components: {
    patientComponent
  }
}
</script>

<style lang="scss" scoped>
</style>